import WorkflowActivationPeriodJson from './interfaces/WorkflowActivationPeriodJson'
import { DateTime } from 'luxon'
import WorkflowActivationPeriod from './WorkflowActivationPeriod'

export default class WorkflowActivationPeriods {
  periods: WorkflowActivationPeriod[]

  constructor(periods: WorkflowActivationPeriod[]) {
    this.periods = periods
  }

  isActive(now: DateTime): boolean {
    for (const period of this.periods) {
      if (period.isActive(now)) {
        return true
      }
    }
    return false
  }

  static fromJson(data: WorkflowActivationPeriodJson[]) {
    return new this(data.map((item) => WorkflowActivationPeriod.fromJson(item)))
  }
}
